module.exports = {
  games: {
    card_timestamp_format: '%{date} %{time} Uhr',
    xes_turn: '%{username} ist am Zug',
    opponents_turn_emoji: '⏳ %{opponentName} ist am Zug',
    startet_at: 'Gestartet am %{date} um %{time} Uhr',
    draw_emoji: 'Dieses Battle endete unentschieden ⚖️',
    choose_random_opponent: 'Zufälliger Gegner',
    game_status_you_won: 'Du hast gewonnen',
    you_won_emoji: 'Du hast dieses Battle gewonnen! 🎉',
    game_status_you_lost: 'Du hast verloren',
    choose_category: 'Kategorie wählen',
    win_short: 'Du hast gewonnen!',
    you_lost_emoji: 'Du hast dieses Battle verloren! 🙈',
    lost_short: 'Du hast verloren.',
    bot_difficulty_2: 'Fortgeschritten',
    opponent_reached_max_game_limit: 'Du hast bereits ein aktives Spiel mit diesem User. Wähle einen anderen Spieler. | Limit an gleichzeitigen Spielen ({count} Spiele) mit diesem User erreicht. Wähle einen anderen Spieler.',
    game_status_aborted_short: 'Abgebrochen',
    quiz_history: 'Beendete Quiz-Battles',
    your_active_battles: 'Deine aktiven Quiz-Battles',
    audio_no_browser_support: 'Dein Browser unterstützt das Audio Element nicht.',
    draw_short: 'Unentschieden',
    game_status_draw: 'Unentschieden',
    game_status_opponent_turn: '%{opponentName} ist dran',
    game_status_my_turn: 'Du bist dran',
    bot_difficulty_1: 'Anfänger',
    begin_quiz: 'Quiz starten',
    play_quiz: 'Quiz spielen',
    game_status_canceled: 'Das Spiel wurde abgebrochen',
    your_time_left: 'Du hast noch %{hours}h %{minutes}m %{seconds}s Zeit zu antworten.',
    your_turn: 'Du bist am Zug',
    rematch: 'Erneut herausfordern',
    challenge_bot: 'Bot herausfordern',
    challenge_again: 'Erneut herausfordern',
    challenge_revenge: 'Zur Revanche herausfordern',
    answer_submission_error: 'Antwort konnte nicht übermittelt werden. Bitte neu auswählen.',
    round_n: 'Runde %{n}',
    next_round: 'Nächste Runde:',
    show_finished_battles: 'Beendete Quiz-Battles anzeigen',
    opponents_time_left: 'Und hat noch %{hours}h %{minutes}m Zeit zu antworten.',
    quiz_stats: 'Quiz-Statistiken',
    time_has_passed: 'Die Zeit ist abgelaufen',
    submit_answer: 'Antwort abschicken',
    your_turn_emoji: '👉 Du bist am Zug!',
  },
  joker_used: '50:50 Joker genutzt',
  joker: '50:50 Joker 🔮',
  answered_correctly: 'Richtig beantwortet!',
  quizteams: {
    add_member_to_team: 'Zum Team hinzufügen',
    add_member: 'Mitglied hinzufügen',
    add_new_member: 'Neues Mitglied hinzufügen',
    admin: 'Admin',
    show_my_teams: 'Meine Quiz Teams anzeigen',
    create_quizteam: 'Team erstellen',
    create_new_quizteam: 'Neues Quiz-Team erstellen',
    create_new: 'Neues Quiz Team anlegen',
    team_details: 'Team details',
    quizteams: 'Teams',
    mine: 'Meine Teams',
    your_teams: 'Deine Quiz-Teams',
    create_description: 'Gib hier den Namen deines Teams ein. Im nächsten Schritt kannst du Mitglieder einladen.',
    add_new_member_description: 'Gib hier einen Benutzernamen ein um ein neues Mitglied hinzuzufügen',
    members: 'Mitglieder',
    no_teams_yet: 'Du bist noch keinem Team beigetreten. Bitte den Admin eines anderen Teams darum, dich aufzunehmen oder gründe dein eigenes Team und lade deine Kolleginnen und Kollegen ein.',
    teamname: 'Teamname',
    all: 'Alle Teams',
    at_least_3_characters: 'Bitte gib mindestens 3 Buchstaben als Teamnamen ein.',
  },
  statistics: {
    show_all_teams: 'Alle Teams anzeigen',
    show_all_players: 'Alle Spieler anzeigen',
    top_quiz_teams: 'Top Teams',
    questions_correct: 'Fragen richtig',
    games_won: 'Spiele gewonnen',
    top_players: 'Top Spieler',
    show_all: 'Zu allen Statistiken',
    questions_correct_percentage: 'Anteil richtig',
    win_quote: 'Siegquote',
    my_statistics: 'Meine Statistiken',
    all_tags: 'Alle Tags',
  },
  search_opponent: 'Gegner suchen',
  answered_incorrectly: 'Das war leider nicht ganz richtig.',
  your_turn_choose_category: 'Du bist am Zug. Wähle eine Kategorie:',
  no_categories: 'Derzeit verfügst du über keine spielbaren Kategorien. Bitte wende dich an deinen Administrator.',
  no_categories_mail: 'Derzeit verfügst du über keine spielbaren Kategorien. Bitte wende dich an: %{adminMail}',
  start_first_quiz: 'Starte jetzt dein erstes Quiz:',
  start_quiz: 'Quiz starten',
  questions: {
    question: 'Frage',
    question_n: 'Frage %{n}',
    your_notes: 'Deine Notizen',
    suggest_questions: 'Quiz-Fragen vorschlagen',
    suggest_new_question: 'Neue Frage vorschlagen',
  },
  start_new_quiz: 'Neues Quiz-Battle starten',
  new_random_opponent: 'Neuer Vorschlag',
  challenge: 'Herausfordern',
  quiz_battle: 'Quiz-Battle',
  feedback: 'Auflösung',
  start_round: 'Los gehts!',
  category_competition_label: 'Gewinnspiel 🏆',
  next_question: 'Nächste Frage',
  vs: 'vs',
}
